angular.module('pitch.app')
.controller('SongwriterProfileCtrl', function($scope, songwriter, Content, ContentsLoader, $sce, $filter) {
    "use strict";

    $scope.songwriter = songwriter;

    $scope.slides = [{
        type: 'image',
        assets:[{
            key: 'main',
            src: $filter('asset')(songwriter.assets, 'profilePhoto').src
        }]
    }];

    $scope.getHtml = function(html) {
        return $sce.trustAsHtml(html);
    };

    $scope.topTracksLoader = new ContentsLoader({
        sortField: 'slot',
        sortOrder: 'ASC',
        featured: true,
        section: 'songwriters/' + songwriter.id + '/featured-tracks'
    }).getAll();

    Content.query({
        sortField: 'slot',
        sortOrder: 'ASC',
        featured: true,
        section: 'songwriters/' + songwriter.id + '/featured-playlists'
    }, function(resp) {
        $scope.featured = resp;
    });

});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SongwriterProfileCtrl.js